import { useSearchContext } from "../../context/search";
import { useAppContext } from "../../context/appContext";
import useCurrentUser from "../../hooks/useCurrentUser";
import { StyledNav } from "../../styles/StyledNav";
import Logo from "../Logo/Logo";
import { Search } from "../Search";
import NavMenu from "./NavMenu";

export default function Nav() {
	const { dispatch } = useSearchContext();
	const { items } = useAppContext();
	// Only users who see decisions have something to search
	const { can } = useCurrentUser({ enabled: items?.isUserLogin === true });

	const setPhrase = (phrase) => {
		localStorage.setItem("search", phrase);
		dispatch({ type: "SET_PHRASE", payload: { phrase } });
	};

	return (
		<StyledNav>
			<Logo />
			{can("viewDecisions") ? <Search advancedSearch={true} setPhrase={setPhrase} /> : <div />}
			<NavMenu />
		</StyledNav>
	);
}
